import UserRecord from '@/models/list/UserRecord';
import APIService from '@/services/APIService';

export default {

  index(params) {
    return APIService.get(
      '/courses/prior-records/', { params, rOptions: { many: true } },
    );
  },

  show(enrollmentId, params) {
    return APIService.get(
      `/courses/prior-records/${enrollmentId}`, { params, rOptions: { signle: true } },
    );
  },

  /**
   * Получить список наборов на курс
   * @param id
   * @returns {Promise<AxiosResponse<T>>}
   */
  getEnrollmentList(id, params) {
    return APIService.get(`/courses/${id}/prior-records`, params);
  },

  getEnrollment(enrollmentId, params) {
    return APIService.get(`/courses/prior-records/${enrollmentId}`, params);
  },

  /**
   * Добавить набор к курсу
   *
   * @param enrollment
   * @param courseId
   * @param obs - validation observer
   * @returns {Promise<AxiosResponse<T>>}
   */
  createEnrollment(enrollment, courseId, obs) {
    return APIService.post(`courses/${courseId}/prior-records`, enrollment, { rOptions: { obs } });
  },

  /**
   * Изменение набора
   *
   * @param enrollment
   * @returns {Promise<AxiosResponse<T>>}
   */
  updateEnrollment(enrollment) {
    return APIService.put(`/courses/prior-records/${enrollment.id}`, enrollment);
  },

  /**
   * Удаление набора
   *
   * @param enrollmentId
   * @returns {Promise<AxiosResponse<T>>}
   */
  deleteEnrollment(enrollmentId) {
    return APIService.delete(`/courses/prior-records/${enrollmentId}`);
  },

  /**
   * Добавить текущего пользователя в набор
   *
   * @param enrollmentId
   * @returns {Promise<AxiosResponse<T>>}
   */
  enrollToCourse(enrollmentId, payload) {
    return APIService.post(`/prior-records/${enrollmentId}/sign-up`, payload);
  },

  /**
   * Получить список пользователей набор
   *
   * @param enrollmentId
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  getEnrollmentUserList(enrollmentId, params) {
    const config = { params };
    return APIService.get(`/courses/prior-records/${enrollmentId}/users`, config);
  },

  getRequestExists(enrollmentId, params) {
    const config = { params };
    return APIService.get(`/courses/prior-records/${enrollmentId}/request-exists`, config);
  },
  /**
   * Получить список доступных заявлений для набора
   */
  statements(config) {
    return APIService.get('/course/prior-records/statement', config);
  },

  /**
   * Получить список аттрибутов для заполнения
   */
  coursePriorRecords(id, params) {
    return APIService.get(`/courses/${id}/prior-records`, { params, rOptions: { many: true } });
  },

  /**
   * Получить список аттрибутов пользователя со значениями по курсу
   */
  coursePriorRecordAttributes(id, params) {
    return APIService.get(
      `/prior-records/${id}/attributes`,
      { params, rOptions: { many: true } },
    );
  },

  /**
   * Сохранить список аттрибутов текущего пользователя
   */
  attributesSave(enrollmentId, data, obs) {
    return APIService.post(
      `/courses/prior-record/${enrollmentId}/attributes/self`,
      data, { rOptions: { obs } },
    );
  },

  /**
   * Получить список сгенерированных заявлений для подписи текущего пользователя
   *
   * @param {Number} enrollmentId id зачисления(набора)
   */
  userSignStatements(enrollmentId, params) {
    return APIService.get(
      `/course/prior-record/${enrollmentId}/statements/sign/user `,
      { params, rOptions: { many: true } },
    );
  },

  userSaveStatement(enrollmentId, statementId, data) {
    return APIService.post(`/course/prior-record/${enrollmentId}/statement/${statementId}/file/user`, data);
  },

  /**
   * Откат(удаление) значение атрибута пользователя в наборе для организации
   *
   * @param {Number} enrollmentId id зачисления(набора)
   * @param {Number} userId id пользователя
   * @param {Number} attributeId id атрибута
   */
  cancelAttr(enrollmentId, userId, attributeId) {
    return APIService.delete(
      `/courses/prior-record/${enrollmentId}/attribute/${attributeId}/user/${userId}`,
    );
  },

  /**
   * Откат(удаление) файла(подписанного заявления) пользователя в наборе для организации
   *
   * @param {Number} scanFileId id загруженного файла
   */
  cancelStatement(scanFileId) {
    return APIService.delete(`/course/prior-record/statement/file/${scanFileId}`);
  },

  /**
   * Получить список пользователей набора для аттестации
   *
   * @param {Number} enrollmentId id зачисления(набора)
   *
   *
      ФИЛЬТРЫ:
      search[full_name] - ФИО
      search[group_id] - группа id
      search[prior_record_status] - статус зачисления
      search[passed_course_units_max] - максимальное количество завершенных тем
      search[passed_course_units_min] - минимальной количество
      search[passed_course_tasks] - true/false 0/1 - 1 - все курсовые пройдены, 0 - не все
   */
  enrollmentUsers(enrollmentId, params, modelParams) {
    return APIService.get(
      `/courses/prior-records/${enrollmentId}/record-users`,
      { params, rOptions: { model: UserRecord, many: true, modelParams } },
    );
  },

  /**
   * Изменить статус ученика в наборе
   *
   * @param {Number} priorRecordUser id ученика в определенном наборе
   */
  changeStatus(priorRecordUser, data) {
    return APIService.put(`prior-record-users/${priorRecordUser}`, data);
  },

  /**
   * Изменить статус списка учеников в наборе
   *
   * @param {Array<{
   *  prior_record_user_id: number,
   *  status: number,
   *  group_id?: number,
   *  reason?: string,
   * }>} records - записи в наборе
   */
  changeStatusMass(records) {
    return APIService.put('prior-record-users/statuses', { records });
  },

  /**
   * Выгрузка студентов в формате excel
   *
   * @param enrollmentId  id зачисления(набора)
   */
  exportStudents(enrollmentId) {
    return APIService.get(`/prior-records/${enrollmentId}/exports/listeners`, { responseType: 'blob' });
  },

  /* Заявка на получение УПК */

  indexUPK(params) {
    return APIService.get('/prior-record-post-data', { params });
  },
  createUPK(data, obs) {
    return APIService.post('/prior-record-post-data', data, { rOptions: { obs } });
  },
  /**
   * @param upkId id заявки
   */
  showUPK(upkId) {
    return APIService.get(`/prior-record-post-data/${upkId}`);
  },
  /**
   * @param upkId id заявки
   */
  updateUPK(upkId, data, obs) {
    return APIService.put(`/prior-record-post-data/${upkId}`, data, { rOptions: { obs } });
  },
  /**
   * @param upkId id заявки
   */
  deleteUPK(upkId) {
    return APIService.delete(`/prior-record-post-data/${upkId}`);
  },
};
